if (!customElements.get("ff-cart-page-line-item"))
  customElements.define(
    "ff-cart-page-line-item",
    class FfCartPageLineItem extends HTMLElement {
      /**
       * @type {string}
       * The id associated to the cart line
       */
      lineId;

      /**
       * @type {HTMLInputElement}
       * The input where line quantity is defined
       */
      inputQty;

      /**
       * @type {HTMLDivElement}
       * Section for the shopify section api
       */
      cartPage;

      /**
       * @type {number}
       * Store the current quantity for the line, just in case a quantity update couldn't be done
       */
      prevQty;

      constructor() {
        super();

        this.lineId = this.id.replace("line-", "");

        /**
         * @type {HTMLSpanElement | null}
         */
        const minusQty = this.querySelector(".ff-js-cart__quantity-remove");
        /**
         * @type {HTMLInputElement | null}
         */
        const inputQty = this.querySelector(".ff-js-cart__quantity-input");
        /**
         * @type {HTMLSpanElement | null}
         */
        const plusQty = this.querySelector(".ff-js-cart__quantity-add");
        /**
         * @type {HTMLElement[] | null}
         */
        const removeBtns = this.querySelectorAll(
          ".ff-js-cart__remove-item-line"
        );
        /**
         * @type {HTMLDivElement | null}
         */
        const cartPage = document.querySelector(".cart-page");

        if (!minusQty || !inputQty || !plusQty || !cartPage || !removeBtns)
          throw new Error();

        this.cartPage = cartPage;
        this.inputQty = inputQty;
        this.prevQty = parseInt(inputQty.value);

        minusQty.addEventListener("click", async () => {
          const newQty = parseInt(inputQty.value || "0") - 1;

          this.inputQty.value = newQty.toString();

          await this.changeQty(newQty);
        });

        plusQty.addEventListener("click", async () => {
          const newQty = parseInt(inputQty.value || "0") + 1;

          this.inputQty.value = newQty.toString();

          await this.changeQty(newQty);
        });

        inputQty.addEventListener("change", async () => {
          const newQty = parseInt(inputQty.value || "0");

          await this.changeQty(newQty);
        });

        inputQty.addEventListener("keypress", async (e) => {
          if (e.key == "Enter") {
            e.preventDefault();
            const newQty = parseInt(inputQty.value || "0");

            await this.changeQty(newQty);
          }
        });

        removeBtns.forEach((btn) =>
          btn.addEventListener("click", async () => {
            await this.changeQty(0);
          })
        );
      }

      /**
       * @param {number} newQty The new qty for the line
       */
      async changeQty(newQty) {
        try {
          document.querySelector(".js-spinner").style.display = "";

          const res = await fetch(
            `${window["Shopify"].routes.root}cart/update.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                updates: { [this.lineId]: newQty <= 0 ? 0 : newQty },
                sections: this.getSectionsToRender().map(
                  (section) => section.id
                ),
              }),
            }
          );

          const result = await res.json();

          if (result?.status === 422) {
            this.inputQty.value = this.prevQty.toString();
          } else {
            this.prevQty = newQty;

            const { item_count } = result;

            if (item_count > 0) {
              this.renderContents(result);
            } else {
              const emptyMsg = document.createElement("div");
              emptyMsg.className = "ff-cart-empty-msg";
              emptyMsg.textContent = this.cartPage.dataset.emptyMsg;
              this.cartPage.replaceChildren(emptyMsg);
            }
          }
        } catch (error) {
          console.log(error);

          this.inputQty.value = this.prevQty.toString();
        } finally {
          document.querySelector(".js-spinner").style.display = "none";
        }
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          const newSectionElement = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );

          if (!sectionElement) {
            return;
          } else if (section.id == this.cartPage.id) {
            this.renderSelf(parsedState.sections[section.id]);
          } else {
            sectionElement.innerHTML = newSectionElement;
          }
        });
      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }

      renderSelf(section) {
        const sectionDOM = new DOMParser().parseFromString(
          section,
          "text/html"
        );

        if (this.prevQty > 0) {
          const updatedCartItem = sectionDOM.querySelector(
            `ff-cart-page-line-item[id="line-${this.lineId}"]`
          );
          const newTotalPrice = updatedCartItem?.querySelector(
            ".js-cart__item-line-price"
          )?.innerHTML;

          const totalPriceEl = this.querySelector(".js-cart__item-line-price");

          if (totalPriceEl && newTotalPrice) {
            totalPriceEl.innerHTML = newTotalPrice;
          }
        } else {
          this.remove();
        }

        const newTotalCart =
          sectionDOM.querySelector(".ff-cart-resume")?.innerHTML;
        const newWarningMessage = sectionDOM.querySelector(
          ".cart-resume-warning"
        );
        const newCheckoutButton = sectionDOM.querySelector(
          ".ff-js-cart__submit"
        );

        const cartTotalPriceEl = this.cartPage.querySelector(".ff-cart-resume");
        const warningMessage = this.cartPage.querySelector(
          ".cart-resume-warning"
        );

        /**
         * @type {HTMLButtonElement}
         */
        const checkoutButton = this.cartPage.querySelector(
          ".ff-js-cart__submit"
        );

        if (newWarningMessage && warningMessage) {
          warningMessage.style.display = newWarningMessage.style.display;
        }

        if (newCheckoutButton && checkoutButton) {
          checkoutButton.style.display = newCheckoutButton.style.display;
        }

        if (cartTotalPriceEl && newTotalCart) {
          cartTotalPriceEl.innerHTML = newTotalCart;
        }
      }

      getSectionsToRender() {
        return [
          {
            id: this.cartPage.id,
          },
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
        ];
      }
    }
  );
